import styled from 'styled-components';

const OrderResumePayment = styled.div`
	background: ${({ theme }) => theme.backgroundOrderResume};

	padding: 15px;
	margin-bottom: 20px;
	//box-shadow: 0 5px 10px 6px ${({ theme }) => theme.boxShadowOrderResume};
	    display: flex;
		flex-direction: column;
		background-color: #f9f9f9;
		border-radius: 10px;
		border: 2px solid ${({ theme }) => theme.borderOrderResume};
		margin:auto;
		//padding-left: 10px;
		height: auto;



	table tr:last-child td {
		border-top: 0px solid
			${({ theme }) => theme.borderTopLastChildTdOrderResume};
		font-family: ${({ theme }) => theme.fontFamilyOrderResume};
		font-size: 18px;
		color: ${({ theme }) => theme.colorTdOrderResume};
		padding: 10px 0 0 0;
		svg {
			color: ${({ theme }) => theme.colorTdSvgOrderResume};
		}
	}



	h2 {
		text-align: center;
		border-bottom: 0px solid ${({ theme }) => theme.borderH2OrderResume};
		padding-bottom: 0px;
		font-size: 24px;
		font-family: ${({ theme }) => theme.fontFamilyOrderResume};
		font-weight: ${({ theme }) => theme.fontWeightH2H4OrderResume};
		color: ${({ theme }) => theme.colorH2H4AnchorIconContainerOrderResume};
	}

	td:empty {
		display: none;
	}

	td:last-child {
		text-align: right;
	}

	tr:last-child td:last-child:empty {
		display: table-cell;
		padding-top: 10px;
		margin-top: 5px;
	}

	.assinantes {
		display: flex;
		justify-content: space-between;
		align-items: center;

	}

	.assinantes a {
		padding: 0;
		svg {
			color: ${({ theme }) => theme.colorH2H4AnchorIconContainerOrderResume};
		}
	}

	.boxAddress p,
	.assinantes p {
		display: inline-block;
		width: 80%;
	}

	.boxAddress h4,
	.boxPrice h4,
	.assinantes h4 {
		font-family: ${({ theme }) => theme.fontFamilyOrderResume};
		font-weight: ${({ theme }) => theme.fontWeightH2H4OrderResume};
		color: ${({ theme }) => theme.colorH2H4AnchorIconContainerOrderResume};
		margin-top: 0;
		margin-bottom: 10px;
	}

	.boxAddress p:after {
		content: '';
		width: 100%;
		height: 3px;
		display: block;
	}

	.assinantes-resume {
		.cards-item-aligment {
			display: flex;
			flex-direction: row;
			width: 100%;
			align-items: center;
			svg {
				margin-right: 10px;
				color: ${({ theme }) => theme.colorIconOrderResume};
			}
			small {
				color: ${({ theme }) => theme.colorSmallOrderResume};
				font-weight: ${({ theme }) => theme.fontWeightSmallOrderResume};
				font-size: 13px;
				overflow: hidden;
				text-overflow: ellipsis;
			}
			span {
				font-size: 13px;
				align-items: center;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
				padding: 0;
				color: ${({ theme }) => theme.colorSpanOrderResume};
				font-weight: ${({ theme }) => theme.fontWeightSpanOrderResume};
			}
		}
	}

	.boxAddress {
		.address-item-aligment {
			display: flex;
			flex-direction: row;
			width: 100%;
			align-items: baseline;
			svg {
				margin-right: 10px;
				color: ${({ theme }) => theme.colorIconOrderResume};
			}
			small {
				color: ${({ theme }) => theme.colorSmallOrderResume};
				font-weight: ${({ theme }) => theme.fontWeightSmallOrderResume};
				font-size: 13px;
			}
			span {
				font-size: 13px;
				align-items: center;
				white-space: break-spaces;
				margin-bottom: 8px;
				overflow: hidden;
				text-overflow: ellipsis;
				padding: 0;
				color: ${({ theme }) => theme.colorSpanOrderResume};
				font-weight: ${({ theme }) => theme.fontWeightSpanOrderResume};
				svg {
					margin-right: 10px;
				}
			}
		}
	}

	.boxPrice {
		.order-item-aligment {
			display: flex;
			flex-direction: row;
			width: 79%;
			align-items: baseline;
			svg {
				margin-right: 10px;
				color: ${({ theme }) => theme.colorIconOrderResume};
			}
			small {
				color: ${({ theme }) => theme.colorSmallOrderResume};
				font-weight: ${({ theme }) => theme.fontWeightSmallOrderResume};
			}
			span {
				font-size: 13px;
				align-items: center;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
				padding: 0;
				color: ${({ theme }) => theme.colorSpanOrderResume};
				font-weight: ${({ theme }) => theme.fontWeightSpanOrderResume};
				margin-bottom: 10px;
				margin-top:0px;
			}
		}

		.cards-item .cards-align{
			align-items: flex-start;
		}

		.cards-item .cards-align .value {
			color: ${({ theme }) => theme.colorValueOrderResume};
		}


		.checkout-box {
			width: 100%;
			span {
				margin-left: 10px;
			}

			td .item {
				padding-right: 10px;

				svg {
					color: ${({ theme }) => theme.colorIconOrderResume};
				}
			}

			.item-cupom {
				padding-bottom: 10px !important;
				input {
					height: 28px;
					border-radius: 10px;
					color: ${({ theme }) => theme.colorInputOrderResume};
				}
			}

			.apply-cupom {
				padding-bottom: 10px;

				.waitingCupom {
					background-color: ${({ theme }) =>
						theme.backgroundWaitingDisabledButtonOrderResume};
					color: ${({ theme }) => theme.colorWaitingDisabledButtonOrderResume};
					border: 0;
					padding: 5px 36px;
					white-space: nowrap;
					position: relative;
					display: flex;
					flex-direction: row;
					justify-content: center;
					align-items: center;
					margin-left: auto;
					border-radius: 25px;
				}

				.apply-code {
					margin-left: auto;
					border-radius: 10px;
					background: ${({ theme }) => theme.backgroundApplyButtonOrderResume};
					color: ${({ theme }) => theme.colorApplyButtonOrderResume};
					border: 0;
					padding: 5px 19px;
					white-space: nowrap;
					position: relative;
					display: flex;
					flex-direction: row;
					justify-content: center;
					align-items: center;
					font-size: 13px
				}

				.isDisabledCart {
					background-color: ${({ theme }) =>
						theme.backgroundWaitingDisabledButtonOrderResume};
					color: ${({ theme }) => theme.colorWaitingDisabledButtonOrderResume};
					border: 0;
					padding: 5px 19px;
					white-space: nowrap;
					position: relative;
					display: flex;
					flex-direction: row;
					justify-content: center;
					align-items: center;
					margin-left: auto;
					border-radius: 10px;
					font-size: 13px
				}
			}

			@media screen and (min-width: 992px) {
				td.item {
					text-align: left;
					width: 60%;
					vertical-align: text-top;
				}
				td.value {
					width: 33%;
					vertical-align: text-top;
				}
			}
		}
	}

	.cards button {
		display: inline-flexbox;
		justify-content: space-between;
		margin: 0;
		border: 0;
		display: block;
		padding: 0;
		text-align: left;
		background-color: transparent;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.address-resume {
		margin: 0;
		border: 0;
		font-size: 18px;
		display: flex;
		justify-content: space-between;
		width: 100%;
		text-align: left;
		background-color: transparent;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		align-items: end;
	}

	.regedit {
		padding:0;
		border: 0;
		background-color: transparent;
	}

	.icon-container {
		background: transparent;
		border-radius: 50%;
		justify-content: center;
		display: flex;
		align-items: center;
		svg {
			color: ${({ theme }) => theme.colorH2H4AnchorIconContainerOrderResume};
		}
	}

	.resume-pix {
		color: ${({ theme }) => theme.colorResumeCupomOrderResume};
	}

	.resume-cupom {
		color: ${({ theme }) => theme.colorResumeCupomOrderResume};
		strong {
			margin-left: 7px;
		}
	}

	.remove-cupom {
		border: none;
    background-color: transparent;
    color: #797977;
		margin-left: 2%;
	}

	@media screen and (min-width: 1200px) {
		top: 5vh;
		//box-shadow: 0 5px 10px 6px ${({ theme }) => theme.boxShadowOrderResume};
	}

	@media (max-width: 992px) {

		h2 {
			padding-top: 10px;
			border-top: 2px solid ${({ theme }) => theme.borderH2OrderResume};
		}

	}

	@media (min-width: 993px) {
		max-width: 490px;
	}

	@media (min-width: 729px) and (max-width: 1360px) {
		h2 {
			font-size: 24px;
		}

		.boxAddress h4 {
			font-size: 18px;
		}
	}
`;

export default OrderResumePayment;
